import React from "react";

import project4_1 from "./assets/projects/bct_1.png";
import project4_2 from "./assets/projects/bct_2.png";
import project4_3 from "./assets/projects/bct_3.png";

import project3_1 from "./assets/projects/mirage_1.png";
import project3_2 from "./assets/projects/mirage_2.png";

// FOR LINE 48: <a className="color-blue hover-underline" href="http://">technology startup company</a>

import project2_1 from "./assets/projects/directory_1.png";
import project2_2 from "./assets/projects/directory_2.png";
import project2_3 from "./assets/projects/directory_3.png";
import project2_4 from "./assets/projects/directory_4.png";

import project1_1 from "./assets/projects/gazetteer_1.png";
import project1_2 from "./assets/projects/gazetteer_2.png";
import project1_3 from "./assets/projects/gazetteer_3.png";
import project1_4 from "./assets/projects/gazetteer_4.png";

export default function ProjectSlides(props) {
    switch (props.project) {
        case "bct":
            return (
                <>
                <div className="project-slides-container">
                    <div className="slide"><img src={project4_1} alt={props.project + "_screenshot_1"}/></div>
                    <div className="slide"><img src={project4_2} alt={props.project + "_screenshot_2"}/></div>
                    <div className="slide"><img src={project4_3} alt={props.project + "_screenshot_3"}/></div>
                </div>
                <div className="project-description-container">
                    <p>This from-the-ground-up <a className="color-blue hover-underline" href="https://bubblecitea.com" target="_blank" rel="noreferrer">redesign of a business website</a> features an improved navigation bar from the business' previous template design, and adds an all-new store locator, multi-page interactive menu, job application mailing system and management database, filtering solution and back-end for complete C.R.U.D. maintenance.</p>
                </div>
                </>
            );
        case "mirage":
            return (
                <>
                <div className="project-slides-container">
                    <div className="slide"><img src={project3_1} alt={props.project + "_screenshot_1"}/></div>
                    <div className="slide"><img src={project3_2} alt={props.project + "_screenshot_2"}/></div>
                </div>
                <div className="project-description-container">
                    <p>A smaller-scale project of the front-end development for a <a className="color-blue hover-underline" href="https://mirage.global" rel="noreferrer"> technology startup company</a>, using supplied and self-created assets and wireframes using Figma and implemented using standard web technologies.</p>
                </div>
                </>
            );
        case "directory":
            return (
                <>
                <div className="project-slides-container">
                    <div className="slide"><img src={project2_1} alt={props.project + "_screenshot_1"}/></div>
                    <div className="slide"><img src={project2_2} alt={props.project + "_screenshot_2"}/></div>
                    <div className="slide"><img src={project2_3} alt={props.project + "_screenshot_3"}/></div>
                    <div className="slide"><img src={project2_4} alt={props.project + "_screenshot_4"}/></div>
                </div>
                <div className="project-description-container">
                <p>An older, no longer maintained solo project of a mobile-first application featuring full C.R.U.D capabilities of maintaining a <a className="color-blue hover-underline" href="https://directory.mangahisjohn.co.uk" target="_blank" rel="noreferrer">company personnel MySQL database</a> and database integrity protection.</p>
                </div>
                </>
            );
        case "gazetteer":
            return (
                <>
                <div className="project-slides-container">
                    <div className="slide"><img src={project1_1} alt={props.project + "_screenshot_1"}/></div>
                    <div className="slide"><img src={project1_2} alt={props.project + "_screenshot_2"}/></div>
                    <div className="slide"><img src={project1_3} alt={props.project + "_screenshot_3"}/></div>
                    <div className="slide"><img src={project1_4} alt={props.project + "_screenshot_4"}/></div>
                </div>
                <div className="project-description-container">
                    <p>Another old, no longer maintained solo project of an expansive <a className="color-blue hover-underline" href="https://map.mangahisjohn.co.uk" target="_blank" rel="noreferrer">geographical index and dictionary</a> that displays profiles and live information, including country and city profiles, live weather, local news headlines, points-of-interest geographical indicators and live street camera feeds<sup>†</sup>.</p>
                </div>
                </>
            );
        default:
            break;
    }
}